import styled from "styled-components";
import { Column } from "uikit";

const Root = styled(Column)`
	overflow: hidden;
`;

export default Root;
